
import { Plan } from "./types";

export const hasActiveYearlyPlan = (
  userSubscriptions: any[],
  productId: string
) => {
  return userSubscriptions.some(sub => {
    const isYearly = sub.plan.name.toLowerCase().includes('yearly');
    const isForProduct = sub.plan.feature_id === productId;
    const isActive = sub.status === 'active';
    const isNotExpired = !sub.end_date || new Date(sub.end_date) > new Date();
    return isYearly && isForProduct && isActive && isNotExpired;
  });
};

export const hasAnySubscription = (
  userSubscriptions: any[],
  productId: string,
  planType: string
) => {
  return userSubscriptions.some(sub => 
    sub.plan.feature_id === productId && 
    sub.plan.type === planType &&
    sub.status === 'active' &&
    (!sub.end_date || new Date(sub.end_date) > new Date())
  );
};

export const shouldDisablePlan = (
  plan: Plan,
  productId: string | undefined,
  userSubscriptions: any[]
) => {
  if (!productId) return false;

  const isYearly = plan.plan_name.toLowerCase().includes('yearly');
  const hasYearlyPlan = hasActiveYearlyPlan(userSubscriptions, productId);

  if (hasYearlyPlan) {
    return true;
  }

  if (!isYearly && hasAnySubscription(userSubscriptions, productId, plan.type)) {
    return true;
  }

  return false;
};

export const getDisabledReason = (
  plan: Plan,
  productId: string | undefined,
  userSubscriptions: any[]
) => {
  if (!productId) return undefined;

  const isYearly = plan.plan_name.toLowerCase().includes('yearly');
  const hasYearlyPlan = hasActiveYearlyPlan(userSubscriptions, productId);

  if (hasYearlyPlan) {
    return "You already have an active yearly subscription for this product";
  }

  if (!isYearly && hasAnySubscription(userSubscriptions, productId, plan.type)) {
    return "You already have an active subscription of this type";
  }

  return undefined;
};
